import React, { useState, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { solicitudApi, infoApi, evidenciaApi, perfilApi } from '../../../../api';
import { isPerfilCompleto } from '../Perfil/Perfil';
import './NuevaSolicitud.css';

const TASA = 0.16;

function calcCuota(monto, plazo) {
  if (!monto || !plazo) return 0;
  const r = TASA;
  const n = plazo;
  return (monto * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
}

// ”€”€ Paso 1: Simulador ”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€”€
const StepSimulador = ({ monto, setMonto, plazo, setPlazo, cuota, total, intereses, tipoCreditoId, setTipoCreditoId, onContinuar, loading, error }) => (
  <div>
    <div className="nueva-page-header">
      <div>
        <h2 className="dash-section-title">Nueva Solicitud de Crédito</h2>
        <p className="dash-section-sub">
          <i className="fa-solid fa-tag"></i> Crédito Personal · Préstamo Rápido · Pago mensual
        </p>
      </div>
    </div>

    <div className="nueva-steps">
      <div className="nueva-step nueva-step--active"><span>1</span> Simulador</div>
      <div className="nueva-step-line"></div>
      <div className="nueva-step"><span>2</span> Requisitos</div>
      <div className="nueva-step-line"></div>
      <div className="nueva-step"><span>3</span> Confirmar</div>
    </div>

    <div className="nueva-layout">
      {/* Simulator card */}
      <div className="dash-card nueva-simulator-card">
        <h3 className="nueva-sim-title">
          <i className="fa-solid fa-calculator"></i> Simulador de cuota
        </h3>

        <div className="nueva-sim-field">
          <div className="nueva-sim-field__top">
            <label>Monto a solicitar</label>
            <span className="nueva-sim-value">S/ {monto.toLocaleString()}</span>
          </div>
          <input type="range" min={500} max={2000} step={100} value={monto}
            onChange={(e) => setMonto(Number(e.target.value))}
            className="nueva-slider"
            style={{ '--pct': `${((monto - 500) / 1500) * 100}%` }}
          />
          <div className="nueva-sim-hints"><span>S/ 500</span><span>S/ 2,000</span></div>
        </div>

        <div className="nueva-sim-field">
          <div className="nueva-sim-field__top">
            <label>Plazo</label>
            <span className="nueva-sim-value">{plazo} {plazo === 1 ? 'mes' : 'meses'}</span>
          </div>
          <input type="range" min={1} max={12} step={1} value={plazo}
            onChange={(e) => setPlazo(Number(e.target.value))}
            className="nueva-slider"
            style={{ '--pct': `${((plazo - 1) / 11) * 100}%` }}
          />
          <div className="nueva-sim-hints"><span>1 mes</span><span>12 meses</span></div>
        </div>

        {/* Tipo de crédito */}
        <div className="nueva-sim-field">
          <div className="nueva-sim-field__top">
            <label>Tipo de préstamo personal</label>
          </div>
          <div className="nueva-tipo-selector">
            <button
              type="button"
              className={`nueva-tipo-btn${tipoCreditoId === 9 ? ' nueva-tipo-btn--active' : ''}`}
              onClick={() => setTipoCreditoId(9)}
            >
              <i className="fa-solid fa-id-card"></i>
              <span>Dependiente</span>
              <small>Ingreso por planilla o RxH</small>
            </button>
            <button
              type="button"
              className={`nueva-tipo-btn${tipoCreditoId === 10 ? ' nueva-tipo-btn--active' : ''}`}
              onClick={() => setTipoCreditoId(10)}
            >
              <i className="fa-solid fa-store"></i>
              <span>Independiente</span>
              <small>Negocio propio</small>
            </button>
          </div>
        </div>

        <div className="nueva-sim-result">
          <div className="nueva-sim-cuota">
            <span>Cuota mensual estimada</span>
            <strong>S/ {cuota.toFixed(2)}</strong>
          </div>
          <div className="nueva-sim-breakdown">
            <div><span>Capital</span><b>S/ {monto.toLocaleString()}</b></div>
            <div><span>Intereses</span><b>S/ {intereses.toFixed(2)}</b></div>
            <div><span>Total</span><b>S/ {total.toFixed(2)}</b></div>
            <div><span>Tasa mensual</span><b>16%</b></div>
            <div><span>Frecuencia</span><b>Mensual</b></div>
            <div><span>Cuotas</span><b>{plazo}</b></div>
          </div>
          <p className="nueva-sim-disclaimer">* Cálculo referencial sujeto a evaluación.</p>
        </div>
      </div>

      {/* Info */}
      <div className="dash-card nueva-info-card">
        <h3 className="nueva-form-title">
          <i className="fa-solid fa-circle-info"></i> ¿Cómo funciona?
        </h3>
        <div className="nueva-como-list">
          <div className="nueva-como-item">
            <div className="nueva-como-num">1</div>
            <div><strong>Simula tu crédito</strong><p>Elige el monto y plazo que mejor se adapte a ti.</p></div>
          </div>
          <div className="nueva-como-item">
            <div className="nueva-como-num">2</div>
            <div><strong>Declara tus requisitos</strong><p>Indica si cuentas con los documentos requeridos.</p></div>
          </div>
          <div className="nueva-como-item">
            <div className="nueva-como-num">3</div>
            <div><strong>Envía y espera</strong><p>Nuestro equipo revisará y se comunicará contigo.</p></div>
          </div>
        </div>
        {error && <div className="dash-alert dash-alert--error" style={{marginTop:'1rem'}}>{error}</div>}
        <button className="btn-primary nueva-submit-btn" onClick={onContinuar} disabled={loading}>
          {loading
            ? <><span className="spinner-sm"></span> Cargando requisitos...</>
            : <><i className="fa-solid fa-arrow-right"></i> Continuar</>
          }
        </button>
      </div>
    </div>
  </div>
);

//  Tarjeta de requisito con carga de archivos 
const RequisitoCarga = ({ req, estado, onChange }) => {
  const inputRef = useRef(null);
  const minArchivos = req.cantidad_imagenes_minimo || 1;
  const archivos = estado.archivos || [];
  const faltan = Math.max(0, minArchivos - archivos.length);
  const cumple = archivos.length >= minArchivos;

  const handleFiles = (newFiles) => {
    const lista = Array.from(newFiles).map((f) => ({
      file: f,
      preview: f.type.startsWith('image/') ? URL.createObjectURL(f) : null,
      name: f.name,
    }));
    onChange({ archivos: [...archivos, ...lista] });
  };

  const handleRemove = (idx) => {
    const next = archivos.filter((_, i) => i !== idx);
    onChange({ archivos: next });
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div className={`req-card${cumple ? ' req-card--ok' : ''}`}>
      <div className="req-card__header">
        <div className="req-card__title">
          <strong>{req.descripcion}</strong>
          <div className="req-card__badges">
            {req.obligatoriedad === 'OBLIGATORIO' && (
              <span className="req-badge req-badge--obligatorio">OBLIGATORIO</span>
            )}
            {req.tipo_evidencia && (
              <span className="req-badge req-badge--tipo">{req.tipo_evidencia}</span>
            )}
            <span className="req-badge req-badge--count">
              {archivos.length}/{minArchivos}
            </span>
          </div>
        </div>
      </div>

      {archivos.length > 0 && (
        <div className="req-files">
          {archivos.map((a, idx) => (
            <div key={idx} className="req-file">
              {a.preview
                ? <img src={a.preview} alt={a.name} className="req-file__thumb" />
                : <div className="req-file__icon"><i className="fa-solid fa-file-lines"></i></div>
              }
              <span className="req-file__name">{a.name}</span>
              <button type="button" className="req-file__remove" onClick={() => handleRemove(idx)}>
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="req-obs-row">
        <input
          type="text"
          className="req-obs-input"
          placeholder="Observación (opcional)..."
          value={estado.observacion || ''}
          onChange={(e) => onChange({ observacion: e.target.value })}
        />
      </div>

      <div
        className="req-dropzone"
        onDrop={handleDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => inputRef.current?.click()}
      >
        <i className="fa-solid fa-cloud-arrow-up"></i> Adjuntar archivo
      </div>
      <input
        ref={inputRef}
        type="file"
        multiple
        accept="image/*,.pdf,.doc,.docx"
        style={{ display: 'none' }}
        onChange={(e) => handleFiles(e.target.files)}
      />

      {!cumple && (
        <div className="req-warning">
          <i className="fa-solid fa-triangle-exclamation"></i> Faltan {faltan} archivo(s)
        </div>
      )}
    </div>
  );
};

//  Paso 2: Requisitos (archivos) + condiciones (Sí/No) 
const StepChecklist = ({ monto, plazo, cuota, infoCredito, tipoCreditoId, onVolver, onSubmit, loading, error }) => {
  const [observaciones, setObservaciones] = useState('');

  // Estado keyed por req.id para no romper índices al filtrar
  const [reqEstado, setReqEstado] = useState(() => {
    const map = {};
    (infoCredito?.requisitos || []).forEach((r) => {
      map[r.id] = { requisito_id: r.id, archivos: [], observacion: '' };
    });
    return map;
  });

  const [condiciones, setCondiciones] = useState(
    (infoCredito?.condiciones || []).map((c) => ({
      condicion_id: c.id,
      cumple: null,
      valor_evaluado: '',
      observacion: '',
    }))
  );

  // Filtrar requisitos según tipo seleccionado
  // Estrategia 1: campo detalle_tipo_credito_id en el objeto req (más confiable)
  // Estrategia 2 (fallback): parsear la descripción buscando palabras clave
  const esDependiente = tipoCreditoId === 9;
  const requisitosVisibles = (infoCredito?.requisitos || []).filter((req) => {
    // Estrategia 1: campo numérico
    if (req.detalle_tipo_credito_id != null) {
      return req.detalle_tipo_credito_id === tipoCreditoId;
    }
    // Estrategia 2: texto en descripción
    const desc = (req.descripcion || '').toUpperCase();
    const esAmbos = desc.includes('DEPENDIENTE E INDEPENDIENTE') || desc.includes('AMBOS');
    if (esAmbos) return true;
    if (esDependiente) return desc.includes('DEPENDIENTE') && !desc.includes('INDEPENDIENTE');
    return desc.includes('INDEPENDIENTE');
  });

  const updateReq = (id, fields) =>
    setReqEstado((prev) => ({ ...prev, [id]: { ...prev[id], ...fields } }));

  const setCondField = (idx, field, value) =>
    setCondiciones((prev) => prev.map((c, i) => (i === idx ? { ...c, [field]: value } : c)));

  const reqObligatorios = requisitosVisibles.filter(r => r.obligatoriedad === 'OBLIGATORIO');
  const reqCumplidos    = reqObligatorios.filter((r) => {
    const min = r.cantidad_imagenes_minimo || 1;
    return (reqEstado[r.id]?.archivos?.length || 0) >= min;
  });
  const progresoPct = reqObligatorios.length > 0
    ? Math.round((reqCumplidos.length / reqObligatorios.length) * 100)
    : 100;

  const condSinResponder = condiciones.filter(c => c.cumple === null).length;
  const puedEnviar = reqCumplidos.length === reqObligatorios.length && condSinResponder === 0;

  const handleSubmit = (e) => {
    e.preventDefault();
    // Solo enviamos los requisitos visibles (del tipo seleccionado)
    const requisitosEstado = requisitosVisibles.map((r) => reqEstado[r.id]);
    onSubmit({ observaciones, requisitosEstado, condicionesEstado: condiciones });
  };

  return (
    <div>
      <div className="nueva-page-header">
        <div>
          <h2 className="dash-section-title">Nueva Solicitud de Crédito</h2>
          <p className="dash-section-sub">
            <i className="fa-solid fa-tag"></i> Crédito Personal  Préstamo Rápido  Pago mensual
          </p>
        </div>
      </div>

      <div className="nueva-steps">
        <div className="nueva-step nueva-step--done"><span><i className="fa-solid fa-check"></i></span> Simulador</div>
        <div className="nueva-step-line nueva-step-line--done"></div>
        <div className="nueva-step nueva-step--active"><span>2</span> Requisitos</div>
        <div className="nueva-step-line"></div>
        <div className="nueva-step"><span>3</span> Confirmar</div>
      </div>

      <div className="dash-card nueva-checklist-summary">
        <div className="nueva-summary">
          <div className="nueva-summary-item">
            <i className="fa-solid fa-sack-dollar"></i>
            <div><label>Monto</label><strong>S/ {monto.toLocaleString()}</strong></div>
          </div>
          <div className="nueva-summary-item">
            <i className="fa-solid fa-calendar-days"></i>
            <div><label>Plazo</label><strong>{plazo} meses</strong></div>
          </div>
          <div className="nueva-summary-item">
            <i className="fa-solid fa-coins"></i>
            <div><label>Cuota mensual</label><strong>S/ {cuota.toFixed(2)}</strong></div>
          </div>
          <div className="nueva-summary-item">
            <i className="fa-solid fa-clock-rotate-left"></i>
            <div><label>Frecuencia</label><strong>Mensual</strong></div>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        {requisitosVisibles.length > 0 && (
          <div className="dash-card nueva-checklist-card">
            <div className="req-section-header">
              <div>
                <h3 className="nueva-checklist-title">
                  <i className="fa-solid fa-list-check"></i> Requisitos del Tipo de Crédito
                  <span className="nueva-checklist-badge">{requisitosVisibles.length}</span>
                </h3>
                <p className="req-section-sub">{reqCumplidos.length} de {reqObligatorios.length} con evidencia</p>
              </div>
              <div className="req-progress-wrap">
                <div className="req-progress-bar">
                  <div className="req-progress-fill" style={{ width: `${progresoPct}%` }}></div>
                </div>
                <span className="req-progress-pct">{progresoPct}%</span>
              </div>
            </div>
            <div className="req-grid">
              {requisitosVisibles.map((req) => (
                <RequisitoCarga
                  key={req.id}
                  req={req}
                  estado={reqEstado[req.id]}
                  onChange={(fields) => updateReq(req.id, fields)}
                />
              ))}
            </div>
          </div>
        )}

        {infoCredito?.condiciones?.length > 0 && (
          <div className="dash-card nueva-checklist-card">
            <h3 className="nueva-checklist-title">
              <i className="fa-solid fa-file-contract"></i> Condiciones
              <span className="nueva-checklist-badge">{infoCredito.condiciones.length}</span>
            </h3>
            <p className="nueva-checklist-sub">Indica si cumples con cada condición del crédito.</p>
            <div className="nueva-checklist-list">
              {infoCredito.condiciones.map((cond, idx) => (
                <div key={cond.id} className={`nueva-check-item${condiciones[idx]?.cumple === true ? ' nueva-check-item--si' : condiciones[idx]?.cumple === false ? ' nueva-check-item--no' : ''}`}>
                  <div className="nueva-check-item__header">
                    <div className="nueva-check-item__info">
                      <strong>{cond.nombre_condicion}</strong>
                      {cond.antiguedad_max_meses && (
                        <span className="nueva-req-badge nueva-req-badge--info">
                          <i className="fa-solid fa-clock"></i> Mín. {cond.antiguedad_max_meses} meses
                        </span>
                      )}
                    </div>
                    <div className="nueva-check-btns">
                      <button type="button"
                        className={`nueva-check-btn nueva-check-btn--si${condiciones[idx]?.cumple === true ? ' active' : ''}`}
                        onClick={() => setCondField(idx, 'cumple', true)}>
                        <i className="fa-solid fa-check"></i> Sí
                      </button>
                      <button type="button"
                        className={`nueva-check-btn nueva-check-btn--no${condiciones[idx]?.cumple === false ? ' active' : ''}`}
                        onClick={() => setCondField(idx, 'cumple', false)}>
                        <i className="fa-solid fa-xmark"></i> No
                      </button>
                    </div>
                  </div>
                  {condiciones[idx]?.cumple !== null && (
                    <div className="nueva-check-obs cond-extras">
                      {cond.antiguedad_max_meses && (
                        <input
                          type="number"
                          min={0}
                          placeholder="Meses (ej: 24)"
                          value={condiciones[idx].valor_evaluado}
                          onChange={(e) => setCondField(idx, 'valor_evaluado', e.target.value)}
                          className="cond-valor"
                        />
                      )}
                      <input
                        type="text"
                        placeholder="Observación (opcional)"
                        value={condiciones[idx].observacion}
                        onChange={(e) => setCondField(idx, 'observacion', e.target.value)}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="dash-card">
          <h3 className="nueva-form-title">
            <i className="fa-solid fa-paper-plane"></i> Confirmar y enviar
          </h3>

          {!puedEnviar && (
            <div className="dash-alert dash-alert--error" style={{ marginBottom: '1rem' }}>
              <i className="fa-solid fa-triangle-exclamation"></i>{' '}
              {reqCumplidos.length < reqObligatorios.length
                ? `Requisitos: Falta evidencia obligatoria (${reqObligatorios.length - reqCumplidos.length} pendiente(s))`
                : `Condiciones: Responde todas las condiciones (${condSinResponder} pendiente(s))`
              }
            </div>
          )}

          {error && <div className="dash-alert dash-alert--error">{error}</div>}

          <div className="dash-field" style={{ marginBottom: '1rem' }}>
            <label>Observaciones generales <span style={{ color: '#aaa', fontWeight: 400 }}>(opcional)</span></label>
            <div className="dash-input-wrap">
              <i className="fa-solid fa-comment"></i>
              <input
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                placeholder="Ej: necesito el crédito para capital de trabajo"
              />
            </div>
          </div>

          <div className="nueva-action-row">
            <button type="button" className="btn-outline" onClick={onVolver} disabled={loading}>
              <i className="fa-solid fa-arrow-left"></i> Volver
            </button>
            <button type="submit" className="btn-primary nueva-submit-btn--inline" disabled={loading || !puedEnviar}>
              {loading
                ? <><span className="spinner-sm"></span> Enviando...</>
                : <><i className="fa-solid fa-paper-plane"></i> Enviar solicitud</>
              }
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

//  Componente principal 
const NuevaSolicitud = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [monto, setMonto]   = useState(1000);
  const [plazo, setPlazo]   = useState(6);
  const [tipoCreditoId, setTipoCreditoId] = useState(9); // 9=Dependiente, 10=Independiente
  const [infoCredito, setInfoCredito] = useState(null);
  const [error, setError]   = useState('');
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);
  const [perfilOk, setPerfilOk] = useState(null); // null = cargando

  useEffect(() => {
    perfilApi.getPerfil()
      .then((data) => setPerfilOk(isPerfilCompleto(data.persona || {})))
      .catch(() => setPerfilOk(true)); // si falla, no bloqueamos
  }, []);

  const cuota     = useMemo(() => calcCuota(monto, plazo), [monto, plazo]);
  const total     = useMemo(() => cuota * plazo, [cuota, plazo]);
  const intereses = useMemo(() => total - monto, [total, monto]);

  const handleContinuar = async () => {
    if (monto < 500 || monto > 2000) { setError('El monto debe estar entre S/ 500 y S/ 2,000.'); return; }
    if (plazo < 1 || plazo > 12)     { setError('El plazo debe ser entre 1 y 12 meses.'); return; }
    setError('');
    setLoading(true);
    try {
      const data = await infoApi.getInfoCredito(1, tipoCreditoId);
      setInfoCredito(data);
      setStep(2);
    } catch (err) {
      setError(err.message || 'No se pudo cargar la información del crédito.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async ({ observaciones, requisitosEstado, condicionesEstado }) => {
    setError('');
    setLoading(true);
    try {
      // Subir archivos de cada requisito
      const reqConUrls = await Promise.all(
        (requisitosEstado || []).map(async (r, idx) => {
          let urls = [];
          if (r.archivos && r.archivos.length > 0) {
            const rawFiles = r.archivos.map((a) => a.file);
            const result = await evidenciaApi.upload(rawFiles);
            urls = result.urls || [];
          }
          const reqInfo = infoCredito?.requisitos?.[idx];
          const min = reqInfo?.cantidad_imagenes_minimo || 1;
          return {
            requisito_id: r.requisito_id,
            cumple: urls.length >= min,
            evidencia_url: urls,
            observacion: r.observacion || '',
          };
        })
      );

      const condFormatted = (condicionesEstado || []).map((c) => ({
        condicion_id: c.condicion_id,
        cumple: c.cumple === true,
        valor_evaluado: c.valor_evaluado ? Number(c.valor_evaluado) : undefined,
        observacion: c.observacion || '',
      }));

      const res = await solicitudApi.solicitarCredito({
        tipo_credito_id: 1,
        detalle_tipo_credito_id: tipoCreditoId,
        monto_solicitado: monto,
        plazo_solicitado: plazo,
        frecuencia_pago: 'MENSUAL',
        observaciones,
        requisitos: reqConUrls,
        condiciones: condFormatted,
      });
      setSuccess(res.solicitud);
    } catch (err) {
      if (err.status !== 401) setError(err.message || 'Error al enviar la solicitud.');
    } finally {
      setLoading(false);
    }
  };

  // Mientras se verifica el perfil, mostrar spinner
  if (perfilOk === null) {
    return (
      <div className="dash-loading">
        <div className="spinner"></div>
      </div>
    );
  }

  // Bloquear si el perfil no está completo
  if (!perfilOk) {
    return (
      <div>
        <h2 className="dash-section-title">Nueva Solicitud de Crédito</h2>
        <div className="dash-card nueva-perfil-bloqueado">
          <div className="nueva-perfil-bloqueado__icon">
            <i className="fa-solid fa-user-xmark"></i>
          </div>
          <h3>Completa tu perfil primero</h3>
          <p>Para solicitar un crédito necesitas tener todos tus datos personales completos.</p>
          <button className="btn-primary" onClick={() => navigate('/dashboard/perfil')}>
            <i className="fa-solid fa-user-gear"></i> Ir a Mi Perfil
          </button>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div>
        <h2 className="dash-section-title">Nueva Solicitud</h2>
        <div className="dash-card nueva-success">
          <div className="nueva-success__icon"><i className="fa-solid fa-circle-check"></i></div>
          <h3>¡Solicitud registrada!</h3>
          <p>Tu solicitud ha sido enviada exitosamente. Nuestro equipo se comunicará contigo pronto.</p>
          <div className="nueva-success__code">
            <span>Código:</span>
            <strong>{success.codigo_solicitud}</strong>
          </div>
          <div className="nueva-success__details">
            <span>Monto: <strong>S/ {success.monto_solicitado}</strong></span>
            <span>Plazo: <strong>{success.plazo_solicitado} meses</strong></span>
            <span>Pago: <strong>MENSUAL</strong></span>
            {success.requisitos_registrados != null && (
              <span>Requisitos: <strong>{success.requisitos_registrados} declarados</strong></span>
            )}
          </div>
          <button className="btn-primary" onClick={() => navigate('/dashboard')}>
            <i className="fa-solid fa-list"></i> Ver mis solicitudes
          </button>
        </div>
      </div>
    );
  }

  if (step === 1) {
    return (
      <StepSimulador
        monto={monto} setMonto={setMonto}
        plazo={plazo} setPlazo={setPlazo}
        cuota={cuota} total={total} intereses={intereses}
        tipoCreditoId={tipoCreditoId} setTipoCreditoId={setTipoCreditoId}
        onContinuar={handleContinuar}
        loading={loading} error={error}
      />
    );
  }

  return (
    <StepChecklist
      monto={monto} plazo={plazo} cuota={cuota}
      infoCredito={infoCredito}
      tipoCreditoId={tipoCreditoId}
      onVolver={() => { setStep(1); setError(''); }}
      onSubmit={handleSubmit}
      loading={loading} error={error}
    />
  );
};

export default NuevaSolicitud;
